import endpoint from "../../config/endpoints";

export const OutletMovingFooterJsons = {
  showSaveNextBtn: false,
  formPath: "",
  screenTitle: "",
  showTitle: false,
  showCancel: false,
  showSaveBtn: false,
  fieldMeta: [
    {
      label: "Beat",
      controlType: "autocomplete",
      placeHolder: "Select Beat",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "beatFooter",
      masterName: "beatDetail",
      isMandatory: true,
      isRootLevelKey: true,
    },
  ],
};
